import { tokens } from '../tokens';

const { fontSize, fontWeight, lineHeight, fontFamily } = tokens;

const headingMap = {
  1: { fontSize: fontSize.h1, fontWeight: fontWeight.bold, lineHeight: lineHeight.tight },
  2: { fontSize: fontSize.h2, fontWeight: fontWeight.semibold, lineHeight: lineHeight.tight },
  3: { fontSize: fontSize.h3, fontWeight: fontWeight.semibold, lineHeight: lineHeight.tight },
} as const;

export const heading = (level: 1 | 2 | 3) => ({
  fontFamily,
  ...headingMap[level],
});

export const body = {
  fontFamily,
  fontSize: fontSize.body,
  fontWeight: fontWeight.regular,
  lineHeight: lineHeight.normal,
};

export const caption = {
  fontFamily,
  fontSize: fontSize.caption,
  fontWeight: fontWeight.regular,
  lineHeight: lineHeight.normal,
};

export const small = {
  fontFamily,
  fontSize: fontSize.small,
  fontWeight: fontWeight.regular,
  lineHeight: lineHeight.normal,
};

export const truncate = {
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden' as const,
  textOverflow: 'ellipsis' as const,
};

export const truncateLines = (n: number) => ({
  display: '-webkit-box' as const,
  WebkitLineClamp: n,
  WebkitBoxOrient: 'vertical' as const,
  overflow: 'hidden' as const,
});
